import React, { useEffect } from 'react';
import { useTestSearchContext } from '../contexts/test-search.context';
import { useLabTestStore } from '../labtest.store';
import httpClient from '../../../../services/http';
import { APIUtils } from '../../../../utils/apiutils';
import { Typography } from '@mui/material';

const CityValidation = () => {
    const { city } = useTestSearchContext();
    // const { validCity, validatingCity } = useLabTestStore();
    // const [loading, setLoading] = useState(false);
    const { updateValidatingCity, updateValidCity, validCity, validatingCity } = useLabTestStore();

    useEffect(() => {
        const handleVerification = async (city) => {
            // setLoading(true);
            updateValidatingCity(true);
            try {
                const url = `${APIUtils.getAPIEndpoint('user:verify-city')}?city=${city}`;
                const res = await httpClient.get(url).then(res => res.data);
                if (res.status === 'success') {
                    // setValid(res.data);
                    updateValidCity(res.data.hasService);
                    return res.data.hasService;
                }
            } catch (e) {
                console.log(e);
                // setError(e);
                updateValidCity(false);
                return false;
            } finally {
                updateValidatingCity(false);
                // setLoading(false);
            }
        };

        if (city) {
            handleVerification(city);
        }
    }, [city, updateValidatingCity, updateValidCity]);

    if (!city) {
        return '';
    }

    const renderMessage = () => {
        if (validatingCity) {
            return 'Checking if service is available in the city';
        }

        if (validCity) {
            return 'Service Available';
        }

        return 'Service Unavailable';
    };

    return (
        <Typography variant="caption" gutterBottom sx={{ display: 'block', width: '100%', fontSize: '14px' }} className={validatingCity ? 'ellipsis-loading' : ''}>
            {renderMessage()}
        </Typography>
    );
};

export default CityValidation;